export default "__VITE_ASSET__Bn4iMpBA__"